import { ApiService } from '../../constants/ApiService';
import { HttpService } from '../../utilities';

interface GetMasterTask {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
  BinusianID?: string;
  take?: number;
  keyword?: string;
  taskCode?: string;
  columnName?: string;
  sortDirection?: string;
  taskId?: string;
  searchByName?: string;
  id?: string;
  delegateEmployeeName?: string;
  status?:string;
  employeeName?: string;
}

export const getTaskDelegation = ({
  BinusianID = '',
  page,
  take,
  columnName,
  delegateEmployeeName,
  taskCode,
  status
}: GetMasterTask) => {
  return HttpService.post(
    `${
      ApiService.icdc.module.task.getTaskDelegation
    }?binusianId=${BinusianID}&page=${page}&take=10000&columnName=${columnName}&delegateEmployeeName=${delegateEmployeeName}&taskCode=${taskCode}&status=${status}`
  ,{});
};

export const getTaskType = () => {
  return HttpService.post(`${ApiService.icdc.module.task.getTaskType}`, {});
};

export const getDelegationUnit = async({BinusianID, keyword}) => {
  const requestBody = {
    BinusianID: BinusianID,
    keyword: keyword
  };
  

  try {
      return HttpService.post(`${ApiService.icdc.module.task.getDelegationUnit}`, requestBody);
  } catch (error) {
      console.error('Error fetching delegation unit:', error);
      throw error;
  }
};

export const getEmployee = ({
  BinusianID,
  keyword
}: GetMasterTask) => {
  return HttpService.get(
    `${ApiService.icdc.module.task.getEmployee}?binusianId=${BinusianID}&keyword=${keyword}`)
}

export const saveTaskDelegation = (data) => {
  return HttpService.post(ApiService.icdc.module.task.saveTaskDelegation, data);
}

export const removeTaskDelegation = (data) => {
  return HttpService.post(ApiService.icdc.module.task.removeTaskDelegation, data);
}

export const getDelegationByType = ({
  BinusianID = '',
  taskCode = '',
  columnName = '',
  sortDirection = '',
  page,
  take
}: GetMasterTask) => {
  return HttpService.post(`${ApiService.icdc.module.task.getDelegationByType}?binusianId=${BinusianID}&taskCode=${taskCode}
    &columnName=${columnName}&sortDirection=${sortDirection}&page=${page}&take=${take}`, {});
}

export const getDetailTaskDelegation = ({taskId} : GetMasterTask) => {
  return HttpService.post(`${ApiService.icdc.module.task.getDetailTaskDelegation}?taskId=${taskId}`, {})
}

export const editTaskDelegation = (data) => {
  return HttpService.post(ApiService.icdc.module.task.editTaskDelegation, data)
}

export const detail = ({id} : GetMasterTask) => {
  return HttpService.get(`${ApiService.icdc.module.task.detail}?id=${id}`)
}


export const getTaskDelegationAdmin = ({
  BinusianID,
  page,
  take,
  columnName,
  delegateEmployeeName,
  taskCode,
  status,
  keyword
}: GetMasterTask) => {
return HttpService.post( `${
  ApiService.icdc.module.task.getTaskDelegationAdmin
}?binusianId=${BinusianID}&page=${page}&take=10000&columnName=${columnName}&delegateEmployeeName=${delegateEmployeeName}&employee=${keyword}&taskCode=${taskCode}&status=${status}`
,{})
}